module.exports = __webpack_public_path__ + "img/pexels-steve-johnson-1572386.4f7623e3.jpg";